<main class="container-lg px-2 pb-3 pb-lg-5">
  <section *ngIf="game; else noGameBlock" class="p-2 bg-darkest rounded-2 my-3 mt-md-0 mb-mt-5">
    <h3 class="fw-bold fs-6 d-sm-none">{{game.name}}</h3>

    <div class="d-block d-sm-flex">
      <div class="col-12 col-sm-4 play-game-image-container position-relative overflow-hidden">
        <img class="rounded-2 w-100 h-auto d-block mx-auto mx-sm-0" [src]="game.getImage('512x512')" [alt]="game.name" (error)="updateNotFoundImgUrl($event)" [ngClass]="{'disabled-game': game.enabled === false || game.disabledByPromo}">
        <div *ngIf="game.tag && (game.tag.includes('beta') || game.tag.toLowerCase().includes('prelaunch'))" class="flag d-flex flex-row align-items-center">
          <img src="assets/icons/beta_sign.svg" alt="beta sign">
          <small class="ms-1">BETA</small>
        </div>

        <div class="overlay position-absolute top-0 start-0 w-100 h-100" (click)="launchGame()" *ngIf="game.enabled !== false && game.disabledByPromo !==true">
          <img src="assets/icons/play_button.svg" alt="play button" class="position-absolute top-50 start-50 translate-middle">
        </div>
        <app-like-label [game]="game" [favouriteGameIds]="favouriteIds"></app-like-label>
      </div>

      <div class="col-12 col-sm-8 d-flex flex-column flex-grow-1 position-relative" *ngIf="game">
        <div class="d-flex flex-column flex-grow-1 justify-content-between">
          <div class="mt-2 mt-sm-0 ms-0 ms-sm-2 flex-sm-grow-1">
<!--            <div *ngIf="badges && badges.length" class="d-flex justify-content-center justify-content-sm-start flex-wrap gap-2">-->
<!--              <a *ngFor="let badge of badges" class="text-decoration-none badge text-wrap link-badge" [routerLink]="badge.routerLink">{{badge.text}}</a>-->
<!--            </div>-->
            <div class="d-flex justify-content-center justify-content-sm-start flex-wrap gap-2">
              <a *ngIf="badges.publisher" class="text-decoration-none badge text-wrap link-badge" [routerLink]="'/providers/' + badges.publisher.routerLink">{{badges.publisher.name}}</a>
              <ng-container *ngIf="badges.categories.length">
                <a *ngFor="let cat of badges.categories" class="text-decoration-none badge text-wrap link-badge" [routerLink]="'/games/' + cat">{{ ('CATEGORIES.' + cat.replace('-','').toUpperCase()) | translate}}</a>
              </ng-container>
              <ng-container *ngIf="badges.subcategories.length">
                <span *ngFor="let subCat of badges.subcategories" class="text-decoration-none badge text-wrap link-badge">{{ subCat }}</span>
              </ng-container>
            </div>
            <h3 class="fw-bold text-primary my-1 d-none d-sm-block">{{game.name}}</h3>
            <p class="my-2 my-sm-0">{{ 'SELECTED_GAME.DESC' | translate : {gameName: game.name, gameCat: game.category ? game.category : '', gameProv: game.publisher} }}</p>
            <ng-container *ngIf="game.features && game.features.length">
                <h5 class="fs-6 my-1">{{ 'SELECTED_GAME.FEATURES.TITLE' | translate }}</h5>
                <ul class="mb-1">
                  <li *ngFor="let feature of game.features"> {{ ('SELECTED_GAME.FEATURES.' + (feature | uppercase)) | translate}}</li>
                </ul>
            </ng-container>
          </div>
          <div class="d-flex justify-content-center mb-2 mb-lg-4">
            <button class="btn btn-primary my-0" (click)="launchGame()" [disabled]="game.enabled === false || game.disabledByPromo === true">{{ 'ACCOUNT.JACKPOT.LAUNCH_GAME_BTN' | translate }}</button>
          </div>
          <div *ngIf="game.disabledByPromo" style="width: 90%;" class="ps-0 ps-sm-2">
            <a routerLink="/account/promotions" class="text-decoration-none text-primary"> {{"PROMOTIONS.ACTIVE_PROMO_TITLE" | translate}} {{ 'PROMOTIONS.ACTIVE_PROMO_TIP' | translate }}</a>
          </div>
        </div>
        <!--   TODO jackpot section commented out -->
<!--        <div *ngIf="jackpot" class="jackpot-overlay">-->
<!--          <div class="d-flex flex-column align-items-center align-items-sm-end">-->
<!--            <app-svg-icon class="variable-svg-icon" [pathIdentifier]="'jackpots'"></app-svg-icon>-->
<!--            <small class="text-center text-sm-end text-primary mb-0"> {{jackpot.value}} {{jackpot.currency}} <br>Jackpot!</small>-->
<!--          </div>-->
<!--        </div>-->
        <div *ngIf="game.disabledByPromo" class="jackpot-overlay d-flex flex-column align-items-center align-items-sm-end">
            <app-svg-icon class="variable-svg-icon" [pathIdentifier]="'promotions'"></app-svg-icon>
        </div>
      </div>
    </div>
  </section>

  <ng-template #noGameBlock>
    <div class="container-lg text-center pt-0 pt-md-3">
        <div class="d-flex flex-column justify-content-center align-items-center p-3 p-md-5 bg-darkest rounded-4">
          <h2>{{ 'NOTFOUND.GAME.TITLE' | translate }}</h2>
          <p class="lead text-center">{{ 'NOTFOUND.GAME.MESSAGE' | translate }}</p>
          <p class="h4 text-center mb-5">{{ 'NOTFOUND.GAME.TODO' | translate }}</p>
          <button class="btn btn-outline-secondary" type="button" routerLink="">{{'NOTFOUND.GAME.HOME_LINK_LABEL' | translate}}</button>
        </div>
    </div>
  </ng-template>



  <div *ngIf="user">
    <app-recent-games></app-recent-games>
    <app-favourite-games></app-favourite-games>
  </div>

  <app-recommended-games></app-recommended-games>



  <section *ngIf="gamesSelectionAll && gamesSelectionAll.length">
    <app-carousel *ngIf="game && badges.categories.length" [dataList]="gamesSelectionByCategory" [identifier]="badges.categories[0]"></app-carousel>

    <app-carousel *ngIf="game && badges.categories.includes('live')" [dataList]="gamesSelectionLive" [identifier]="'live'"></app-carousel>
    <app-carousel *ngIf="game && badges.categories.includes('new')" [dataList]="gamesSelectionNew" [identifier]="'new'"></app-carousel>
    <app-carousel *ngIf="game && badges.categories.includes('top')" [dataList]="gamesSelectionTop" [identifier]="'top'"></app-carousel>
    <app-carousel *ngIf="game && badges.categories.includes('featured')" [dataList]="gamesSelectionFeatured" [identifier]="'featured'"></app-carousel>

    <app-carousel *ngIf="game" [dataList]="gamesSelectionByProvider" [identifier]="'provider'"></app-carousel>

    <app-carousel [dataList]="gamesSelectionAll" [identifier]="'all'"></app-carousel>

  </section>

  <app-providers-carousel></app-providers-carousel>


</main>

